export default {
  driver_performance_dashboard: "Consola",
  driver_performance_driver: "Conductores",
  driver_performance_events: "Eventos",
  driver_performance_cases: "Casos",

  //Events
  driver_performance_Asleep: "Dormido",
  driver_performance_CameraObstructed: "Cámara Obstruida",
  driver_performance_CloseFollowing: "Conducción muy Cercana",
  driver_performance_CollisionWarning: "Alerta de Colisión",
  driver_performance_CyclistWarning: "Alerta de Ciclista",
  driver_performance_Distracted: "Distraído",
  driver_performance_Drowsiness: "Somnolencia",
  driver_performance_HardAcceleration: "Aceleración Fuerte",
  driver_performance_HardBrake: "Frenado Brusco",
  driver_performance_HardTurn: "Giro Brusco",
  driver_performance_IdleNoDriver: "Inactivo sin Conductor",
  driver_performance_LaneDeparture: "Salida de Carril",
  driver_performance_NoSeatbelt: "Sin Cinturón de Seguridad",
  driver_performance_ParkingHit: "Golpe en Estacionamiento",
  driver_performance_PassengerInside: "Pasajero a Bordo",
  driver_performance_PassengerSeatbelt: "Pasajero sin Cinturón",
  driver_performance_PedestrianDetection: "Detección de Peatón",
  driver_performance_PostedSpeed: "Velocidad Permitida",
  driver_performance_PotentialIncident: "Incidente Potencial",
  driver_performance_RapidAcceleration: "Aceleración Brusca",
  driver_performance_Smoking: "Fumando",
  driver_performance_SpeedThreshold: "Límite de Velocidad",
  driver_performance_StopSignViolation: "Infracción de Señal de Alto",
  driver_performance_Tailgating: "Emergencia de Proximidad",
  driver_performance_UsingPhone: "Usando teléfono",
  driver_performance_Yawn: "Bostezo",
  driver_performance_PotentialIncidentMedium: "Incidente Potencial",
  driver_performance_PotentialIncidentHigh: "Incidente Potencial",
  driver_performance_PotentialIncidentLow: "Incidente Potencial",
  driver_performance_UnassignedDriver: "Conductor no Asignado",
  driver_performance_SpeedOverPosted: "Exceso de Velocidad Permitida",
  driver_performance_ECUSpeedOverPosted: "Exceso de Velocidad ECU Permitida",
  driver_performance_SpeedOver: "Exceso de Velocidad",
  driver_performance_UsingPhone: "Usando el teléfono",
  driver_performance_SDCardError: "Error de Tarjeta SD",
  driver_performance_PowerLost: "Pérdida de Energía",
  driver_performance_ParkingHit: "Golpe en Estacionamiento"
};
